/**
 * 更新 .text 結構的顯示頁面
 */
export const updateTextDisplay = (contentRef, pageIndex) => {
  if (!contentRef.current) return;
  
  // === 新增：偵測多區塊結構 ===
  const questionEl = contentRef.current.querySelector('#question');
  const answerEl = contentRef.current.querySelector('#answer');
  const analyzeEl = contentRef.current.querySelector('#analyze');
  const hasMultiSection = !!(questionEl && (answerEl || analyzeEl));

  if (hasMultiSection) {
    // --- 1. #question 的 .text：用位置索引控制 ---
    const textElements = questionEl.querySelectorAll('.text');
    textElements.forEach((textEl, index) => {
      if (index === pageIndex) {
        textEl.style.visibility = 'visible';
        textEl.style.position = 'relative';
      } else {
        textEl.style.visibility = 'hidden';
        textEl.style.position = 'absolute';
      }
    });

    // --- 2. .title 只在 page 0 顯示 ---
    const questionTitles = questionEl.querySelectorAll('.title');
    questionTitles.forEach(titleEl => {
      titleEl.style.display = pageIndex === 0 ? '' : 'none';
    });

    // --- 3. 標題圖片（.img div）只在 page 0 顯示 ---
    if (textElements.length > 0) {
      const firstText = textElements[0];
      const imgDivs = questionEl.querySelectorAll('div.img');
      imgDivs.forEach(imgDiv => {
        const isBefore = !!(imgDiv.compareDocumentPosition(firstText) & Node.DOCUMENT_POSITION_FOLLOWING);
        if (isBefore) {
          imgDiv.style.display = pageIndex === 0 ? '' : 'none';
        }
      });
      
      // 前置 <br> 也只在 page 0 顯示
      const allBr = contentRef.current.querySelectorAll('br');
      allBr.forEach(br => {
        if (br.compareDocumentPosition(firstText) & Node.DOCUMENT_POSITION_FOLLOWING) {
          br.style.display = pageIndex === 0 ? '' : 'none';
        }
      });
    }

    // --- 4. 帶有 data-page-index 的元素：依頁碼顯示/隱藏 ---
    const pageIndexedEls = contentRef.current.querySelectorAll('[data-page-index]');
    pageIndexedEls.forEach(el => {
      const targetPage = parseInt(el.getAttribute('data-page-index'), 10);
      if (pageIndex === targetPage) {
        el.style.display = '';
        el.style.visibility = 'visible';
        el.style.position = 'relative';
        // 復原內部可能被 updateDisplayPage 隱藏的 .text
        el.querySelectorAll('.text, .title').forEach(child => {
          child.style.visibility = 'visible';
          child.style.position = 'relative';
        });
      } else {
        el.style.display = 'none';
      }
    });

    // --- 5. #answer / #analyze 若沒有 data-page-index 則預設隱藏 ---
    [answerEl, analyzeEl].forEach(el => {
      if (!el) return;
      if (!el.hasAttribute('data-page-index')) {
        // 沒有分頁資訊時：保持區塊可見，讓 .title 顯示、.ans 交由 CSS 控制
        el.style.display = '';
        el.style.visibility = 'visible';
        el.style.position = 'relative';
      }
    });

    // --- 6. 處理 .abreast_subject 中圖片的顯示狀態（只在第一頁顯示）---
    const abreastSubjects = questionEl.querySelectorAll('.abreast_subject');
    abreastSubjects.forEach(abreast => {
      const imgs = abreast.querySelectorAll('img');
      imgs.forEach(img => {
        // 只處理不在 .text 內的圖片
        if (!img.closest('.text')) {
          img.style.display = pageIndex === 0 ? '' : 'none';
        }
      });
    });

    return; // 多區塊處理完畢，不走原有邏輯
  }

  // 處理所有 .text element 的顯示狀態
  const textElements = contentRef.current.querySelectorAll('.text');
  textElements.forEach((textEl, index) => {
    if (index === pageIndex) {
      textEl.style.visibility = 'visible';
      textEl.style.position = 'relative';
    } else {
      textEl.style.visibility = 'hidden';
      textEl.style.position = 'absolute';
    }
  });

  // 圖片型（.imageSet）版型：左欄圖片必須保留在「每一頁」（驗收標準：每個分頁的左邊圖片要留著），與題目型「圖片獨立一頁、只在第一頁顯示」的規則相反。
  // 結構為 .imageSet > .title + .abreast > .img + .text，與 SynopsisWindow 的分頁策略一致
  const isImageSet = !!contentRef.current.querySelector('.imageSet');

  // 處理所有 .title element 的顯示狀態
  const titleElements = contentRef.current.querySelectorAll('.title');
  titleElements.forEach(titleEl => {
    // 圖片型（.imageSet）：標題列每頁都要有（驗收標準），規則與上面左欄圖片一致；
    // 其他版型維持原本「標題只在第一頁顯示」。
    const shouldShow = isImageSet || pageIndex === 0;
    titleEl.style.visibility = shouldShow ? 'visible' : 'hidden';
    titleEl.style.position = shouldShow ? 'relative' : 'absolute';
  });
  
  // 處理第一個 .text element 前面的 <br> 和 <img> 元素（標題圖片）
  // 以及最後一個 .text element 後面的 <img> 元素（.abreast_subject 後面的圖片）
  if (textElements.length > 0) {
    const firstTextElement = textElements[0];
    const lastTextElement = textElements[textElements.length - 1];
    const lastPageIndex = textElements.length - 1;
    
    // 找到容器中所有的 <br> 和 <img> 元素
    const allBrElements = contentRef.current.querySelectorAll('br');
    const allImgElements = contentRef.current.querySelectorAll('img');
    
    // 收集所有在第一個 .text 之前的 <br> 和 <img> 元素（標題圖片）
    const precedingElements = [];
    
    // 檢查每個 <br> 是否在第一個 .text 之前
    allBrElements.forEach(br => {
      if (br.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING) {
        precedingElements.push(br);
      }
    });
    
    // 檢查每個 <img> 是否在第一個 .text 之前（標題圖片）
    allImgElements.forEach(img => {
      if (img.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING) {
        precedingElements.push(img);
      }
    });
    
    // 題目型（topic）：#question 內的附圖（例如 .subject 的數線圖）屬於題目本體。
    // #question 不會被分頁隱藏，所以這些圖片不能跟著頁碼開關——一旦被釘在某一頁，
    // 題幹所在的頁面就看不到圖（NBK-1662 圖片消失）。它們一律保持可見。
    const isTopicLayout = !!contentRef.current.querySelector('.topic');
    const isQuestionContentImage = (el) =>
      isTopicLayout &&
      el.tagName === 'IMG' &&
      !!el.closest('#question') &&
      !el.closest('.img') &&
      !el.closest('.imgSize');

    allImgElements.forEach(img => {
      if (isQuestionContentImage(img)) {
        img.style.visibility = 'visible';
        img.style.position = 'relative';
      }
    });

    // 收集所有在最後一個 .text 之後的 <img> 元素（.abreast_subject 後面的圖片）
    const followingElements = [];
    allImgElements.forEach(img => {
      // 題目本體的附圖已固定為可見，不納入依頁碼開關的集合
      if (isQuestionContentImage(img)) return;
      // 檢查圖片是否在最後一個 .text 之後
      if (lastTextElement.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_FOLLOWING) {
        followingElements.push(img);
      }
    });
    
    // 處理標題圖片：
    // - 如果元素在 .img div 內，固定在第一頁顯示
    // - 如果不在 .img div 內，根據 data-second-page 屬性決定顯示頁面
    precedingElements.forEach(el => {
      // 檢查元素是否在 .img div 內
      const isInImgDiv = el.closest('.img') !== null;
      const isInImgSizeDiv = el.closest('.imgSize') !== null;
      
      if (isInImgDiv || isInImgSizeDiv) {
        // 圖片型（.imageSet）：左欄圖片每一頁都要顯示；
        // 其他版型維持原本「.img div 內的內容固定在第一頁顯示」不會破壞 .abreast 的左右各半版面。
        const shouldShow = isImageSet || pageIndex === 0;
        el.style.visibility = shouldShow ? 'visible' : 'hidden';
        el.style.position = shouldShow ? 'relative' : 'absolute';
      } else {
        // 不在 .img div 內的元素，根據 data-second-page 屬性決定
        const isSecondPageImage = el.tagName === 'IMG' && el.getAttribute('data-second-page') === 'true';
        
        if (isSecondPageImage) {
          // 標題圖片在第二頁顯示
          const shouldShow = pageIndex === 1;
          el.style.visibility = shouldShow ? 'visible' : 'hidden';
          el.style.position = shouldShow ? 'relative' : 'absolute';
        } else {
          // 標題圖片在第一頁顯示（或 <br> 元素）
          const shouldShow = pageIndex === 0;
          el.style.visibility = shouldShow ? 'visible' : 'hidden';
          el.style.position = shouldShow ? 'relative' : 'absolute';
        }
      }
    });

    // 處理最後一頁的圖片：只有在最後一頁時才顯示
    const shouldShowFollowing = pageIndex === lastPageIndex;
    followingElements.forEach(el => {
      if (shouldShowFollowing) {
        el.style.visibility = 'visible';
        el.style.position = 'relative';
      } else {
        el.style.visibility = 'hidden';
        el.style.position = 'absolute';
      }
    });
    
    // 處理獨立頁面的圖片：每個非標題圖片獨立一頁顯示
    allImgElements.forEach(img => {
      const isStandalonePage = img.getAttribute('data-standalone-page') === 'true';
      
      if (isStandalonePage) {
        // 獲取圖片應該顯示的頁面索引
        const pageIndexAttr = img.getAttribute('data-page-index');
        const targetPageIndex = pageIndexAttr ? parseInt(pageIndexAttr, 10) : -1;
        
        // 只在對應的頁面顯示
        const shouldShow = pageIndex === targetPageIndex;
        img.style.visibility = shouldShow ? 'visible' : 'hidden';
        img.style.position = shouldShow ? 'relative' : 'absolute';
      }
    });
    
    // 處理內容圖片：根據標記決定在第二頁顯示
    // 內容圖片必須在第二頁顯示，第一頁隱藏
    allImgElements.forEach(img => {
      const isContentImage = img.getAttribute('data-content-image') === 'true';
      
      if (isContentImage) {
        // 確認不是標題圖片（不在 precedingElements 中）
        const isNotPrecedingImage = !precedingElements.includes(img);
        // 確認不是最後一頁的圖片（不在 followingElements 中）
        const isNotFollowingImage = !followingElements.includes(img);
        
        if (isNotPrecedingImage && isNotFollowingImage) {
          // 內容圖片只在第二頁顯示
          const shouldShow = pageIndex === 1;
          img.style.visibility = shouldShow ? 'visible' : 'hidden';
          img.style.position = shouldShow ? 'relative' : 'absolute';
        }
      }
    });
  }
};

/**
 * 調整圖片大小以適應頁面高度
 * 當圖片高度超過頁面可用高度時，按比例縮小圖片
 */
export const adjustImagesToFitPage = (contentRef, pageIndex) => {
  if (!contentRef.current) return;

  // 獲取容器（頁面）的可用高度
  const container = contentRef.current.parentElement;
  if (!container) return;

  // 強制重排以確保測量準確
  void container.offsetHeight;

  // 獲取容器的總高度
  const containerHeight = container.clientHeight;
  if (containerHeight <= 0) return;

  // 計算當前頁面的實際可用高度
  // 需要扣除標題、前置元素等占用的空間
  const textElements = contentRef.current.querySelectorAll('.text');
  const currentTextElement = textElements[pageIndex];
  
  // 計算當前可見的 .text 元素占用的高度
  let currentTextElementHeight = 0;
  if (currentTextElement) {
    const style = window.getComputedStyle(currentTextElement);
    if (style.visibility !== 'hidden') {
      currentTextElementHeight = currentTextElement.offsetHeight || 0;
    }
  }
  
  // 實際可用高度 = 容器高度 - 當前可見的 .text 元素高度
  const actualContainerHeight = containerHeight - currentTextElementHeight;
  
  // 如果實際可用高度小於等於 0，跳過處理
  if (actualContainerHeight <= 0) return;

  // 找到當前頁面中所有可見的圖片
  const allImages = contentRef.current.querySelectorAll('img');
  const visibleImages = Array.from(allImages).filter(img => {
    // 只處理可見的圖片
    const style = window.getComputedStyle(img);
    const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
    
    // 檢查圖片是否在可見區域內（不是絕對定位到頁面外）
    if (isVisible) {
      const rect = img.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      
      // 檢查圖片是否與容器有重疊（至少部分可見）
      const isInViewport = !(
        rect.bottom < containerRect.top ||
        rect.top > containerRect.bottom ||
        rect.right < containerRect.left ||
        rect.left > containerRect.right
      );
      
      return isInViewport;
    }
    
    return false;
  });

  // 計算標題占用的高度（僅第一頁）
  let titleHeight = 0;
  if (pageIndex === 0) {
    const titleElements = contentRef.current.querySelectorAll('.title');
    titleElements.forEach(titleEl => {
      const style = window.getComputedStyle(titleEl);
      if (style.visibility !== 'hidden') {
        titleHeight += titleEl.offsetHeight || 0;
      }
    });
  }
  
  // 計算前置圖片占用的高度（僅第一頁）
  let precedingImagesHeight = 0;
  if (pageIndex === 0 && textElements.length > 0) {
    const firstTextElement = textElements[0];
    const allImages = contentRef.current.querySelectorAll('img');
    
    allImages.forEach(img => {
      const isPreceding = img.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING;
      if (isPreceding) {
        const style = window.getComputedStyle(img);
        if (style.visibility !== 'hidden' && style.display !== 'none') {
          // 獲取圖片的實際高度（如果已經被縮放過，使用當前高度）
          const imgHeight = img.offsetHeight || img.naturalHeight || 0;
          precedingImagesHeight += imgHeight;
        }
      }
    });
  }
  
  // 計算當前 .text 元素內其他內容的高度（用於計算圖片在 .text 內部的可用空間）
  let textContentHeight = 0;
  if (currentTextElement) {
    // 獲取 .text 元素內除了圖片以外的其他內容高度
    const textClone = currentTextElement.cloneNode(true);
    const imagesInText = textClone.querySelectorAll('img');
    imagesInText.forEach(img => img.remove()); // 移除圖片以測量其他內容高度
    
    // 創建臨時元素測量高度
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.visibility = 'hidden';
    tempDiv.style.width = currentTextElement.offsetWidth + 'px';
    tempDiv.className = currentTextElement.className;
    tempDiv.innerHTML = textClone.innerHTML;
    document.body.appendChild(tempDiv);
    
    textContentHeight = tempDiv.offsetHeight || 0;
    document.body.removeChild(tempDiv);
  }
  
  // 處理每張可見的圖片
  visibleImages.forEach(img => {
    // 判斷圖片的位置類型
    const isInTextElement = currentTextElement && currentTextElement.contains(img);
    const isPrecedingImage = textElements.length > 0 && 
      (img.compareDocumentPosition(textElements[0]) & Node.DOCUMENT_POSITION_FOLLOWING);
    const isStandalonePage = img.getAttribute('data-standalone-page') === 'true';
    const isContentImage = img.getAttribute('data-content-image') === 'true';
    
    // 計算圖片的實際可用高度
    // 使用 actualContainerHeight（已扣除 .text 元素高度）作為基礎
    let actualAvailableHeight = actualContainerHeight;
    
    if (isInTextElement) {
      // 圖片在 .text 元素內部
      // 計算圖片上方已經占用的空間
      
      // 計算圖片上方已占用的空間（標題 + 前置圖片 + 圖片上方的其他內容）
      let usedHeightAbove = 0;
      
      if (pageIndex === 0) {
        usedHeightAbove += titleHeight;
        usedHeightAbove += precedingImagesHeight;
      }
      
      // 計算圖片在 .text 元素中的位置
      // 獲取圖片上方在 .text 元素中的內容高度
      
      // 計算圖片上方在 .text 中的其他內容高度
      // 創建一個臨時元素，只包含圖片上方的內容
      const textClone = currentTextElement.cloneNode(true);
      const allNodes = Array.from(textClone.childNodes);
      
      // 找到圖片在 DOM 中的位置
      let imgIndexInText = -1;
      allNodes.forEach((node, index) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG') {
          const clonedImg = textClone.querySelectorAll('img')[Array.from(currentTextElement.querySelectorAll('img')).indexOf(img)];
          if (clonedImg && (clonedImg === node || node.contains(clonedImg))) {
            imgIndexInText = index;
          }
        }
      });
      
      // 如果找到圖片位置，計算上方內容高度
      if (imgIndexInText >= 0) {
        const nodesAboveImg = allNodes.slice(0, imgIndexInText);
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.visibility = 'hidden';
        tempDiv.style.width = currentTextElement.offsetWidth + 'px';
        tempDiv.className = currentTextElement.className;
        nodesAboveImg.forEach(node => tempDiv.appendChild(node.cloneNode(true)));
        document.body.appendChild(tempDiv);
        const heightAboveImg = tempDiv.offsetHeight || 0;
        document.body.removeChild(tempDiv);
        usedHeightAbove += heightAboveImg;
      }
      
      // 實際可用高度 = 實際容器高度（已扣除 .text 元素） - 圖片上方已占用的空間
      actualAvailableHeight = actualContainerHeight - usedHeightAbove;
      
    } else if (isPrecedingImage && pageIndex === 0) {
      // 標題圖片，可用高度 = 實際容器高度 - 標題高度
      actualAvailableHeight = actualContainerHeight - titleHeight;
    } else if (isStandalonePage || isContentImage) {
      // 獨立頁面圖片或內容圖片，可以使用整個實際容器高度
      actualAvailableHeight = actualContainerHeight;
    }
    
    // 確保可用高度至少為實際容器高度的 50%（避免過度縮小）
    actualAvailableHeight = Math.max(actualAvailableHeight, actualContainerHeight * 0.5);
    
    // 確保圖片已載入（如果還沒載入，等待載入完成後再處理）
    if (!img.complete) {
      img.onload = () => {
        resizeImageIfNeeded(img, actualAvailableHeight);
      };
      // 如果圖片載入失敗，也要處理
      img.onerror = () => {
        resizeImageIfNeeded(img, actualAvailableHeight);
      };
    } else {
      resizeImageIfNeeded(img, actualAvailableHeight);
    }
  });
};

/**
 * 檢查並調整單張圖片的大小
 * @param {HTMLElement} img - 圖片元素
 * @param {number} actualAvailableHeight - 實際可用高度（從圖片位置到容器底部的距離）
 */
const resizeImageIfNeeded = (img, actualAvailableHeight) => {
  
  // 強制重排以確保測量準確
  void img.offsetHeight;

  // 獲取圖片的實際高度（優先使用 naturalHeight，因為這是圖片的原始高度）
  const currentImgHeight = img.offsetHeight || 0;
  const naturalImgHeight = img.naturalHeight || img.height || 0;

  // 使用較大的值作為判斷基準（如果圖片已經被縮放，使用當前高度；否則使用原始高度）
  const imgHeight = currentImgHeight > 0 ? currentImgHeight : naturalImgHeight;

  // 如果圖片高度為 0 或無效，跳過
  if (!imgHeight || imgHeight <= 0) return;

  // 計算可用高度（留一些邊距，避免緊貼邊緣）
  const padding = 10; // 上下各留 5px 邊距
  const availableHeight = actualAvailableHeight - padding;

  // 如果圖片高度超過可用高度，需要縮放
  if (imgHeight > availableHeight) {
    
    // 計算縮放比例
    const scaleRatio = availableHeight / imgHeight;
    
    // 獲取圖片的原始寬度和高度（如果之前已經縮放過，需要還原）
    let originalWidth = img.getAttribute('data-original-width');
    let originalHeight = img.getAttribute('data-original-height');
    
    if (!originalWidth || !originalHeight) {
      // 如果沒有保存原始尺寸，使用 naturalWidth/naturalHeight
      originalWidth = img.naturalWidth || img.width || img.offsetWidth;
      originalHeight = img.naturalHeight || img.height || img.offsetHeight;
      
      // 保存原始尺寸
      if (originalWidth && originalHeight) {
        img.setAttribute('data-original-width', originalWidth);
        img.setAttribute('data-original-height', originalHeight);
      }
    } else {
      // 轉換為數字
      originalWidth = parseFloat(originalWidth);
      originalHeight = parseFloat(originalHeight);
    }
    
    // 如果原始尺寸無效，跳過
    if (!originalWidth || !originalHeight || originalWidth <= 0 || originalHeight <= 0) {
      return;
    }
    
    // 計算新的寬度和高度（基於原始尺寸進行縮放）
    const newHeight = availableHeight * 0.9;
    const newWidth = originalWidth * scaleRatio * 0.9;
    
    // 應用新的尺寸
    img.style.width = `${newWidth}px`;
    img.style.height = `${newHeight}px`;
    img.style.maxWidth = '100%'; // 確保寬度不會超過容器
    img.style.objectFit = 'contain'; // 保持圖片比例
    
  } else {
    // 如果圖片沒有超出，檢查是否需要恢復原始大小
    const originalWidth = img.getAttribute('data-original-width');
    const originalHeight = img.getAttribute('data-original-height');
    
    if (originalWidth && originalHeight) {
      const originalWidthNum = parseFloat(originalWidth);
      const originalHeightNum = parseFloat(originalHeight);
      
      // 檢查當前尺寸是否與原始尺寸不同（表示之前被縮放過）
      const currentWidth = img.offsetWidth || img.width;
      const currentHeight = img.offsetHeight || img.height;
      
      // 如果當前尺寸與原始尺寸差異較大，可能是之前縮放過，現在需要恢復
      const widthDiff = Math.abs(currentWidth - originalWidthNum);
      const heightDiff = Math.abs(currentHeight - originalHeightNum);
      
      // 如果差異很小（小於 1px），視為已恢復，不需要再處理
      if (widthDiff > 1 || heightDiff > 1) {
        // 檢查恢復原始大小後是否會超出實際可用高度
        if (originalHeightNum <= availableHeight) {
          // 可以恢復原始大小
          img.style.width = '';
          img.style.height = '';
          img.style.maxWidth = '';
          img.removeAttribute('data-original-width');
          img.removeAttribute('data-original-height');
        }
      }
    }
  }
};